import { render, staticRenderFns } from "./PEPersonalDetails.vue?vue&type=template&id=129a1535&"
import script from "./PEPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./PEPersonalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports